type Props = {
  className?: string;
  height?: number;
};

// Top-of-page Foton logo. SVG asset at /logo-foton.svg has #EDEDED fill on
// the wordmark — fine on dark BG; we re-color via CSS filter when needed.
export function Logo({ className = "", height = 28 }: Props) {
  return (
    <img
      src="/logo-foton.svg"
      alt="Foton"
      height={height}
      style={{ height: `${height}px`, width: "auto" }}
      className={className}
    />
  );
}
